/**
 * 技术性能埋点事件名（ARMS performance 分组）
 *
 * @description 与业务埋点 `ETrackerEvents`（@/utils/tracker）分离；上报走 reportPerformanceEvent
 */
export enum EPerformanceEvents {
    /**
     * 阅读器首进性能（reader_perf）
     * @see ./reader/event.ts IReaderPerfTrackParams
     */
    READER_PERF = 'reader_perf',

    /** H5 整页冷启加载（Navigation/Paint Timing，每文档一次） */
    H5_COLD_LOAD_PERF = 'h5_cold_load_perf',
    /** H5 SPA 路由切换（pathname → 双 rAF，每次切页） */
    H5_SPA_ROUTE_PERF = 'h5_spa_route_perf',

    // ── 阅读器三步独立埋点（替代聚合 reader_perf） ──
    /** 阅读器页面加载（navigationStart → 骨架屏消失） */
    READER_PAGE_LOAD = 'reader_page_load',
    /** 阅读器接口加载（book_detail / chapter_meta / chapter_content 耗时） */
    READER_API_LOAD = 'reader_api_load',
    /** 阅读器内容渲染（navigationStart → 正文首帧） */
    READER_CONTENT_RENDER = 'reader_content_render',

    /** 阅读器组件挂载（navigationStart → ReaderRoot mount，立即发送） */
    READER_MOUNT = 'reader_mount',

    /** 阅读器 profile hydration 等待耗时（useLandingData 中 await getProfileHydrationInflight，立即发送） */
    READER_PROFILE_HYDRATION = 'reader_profile_hydration',
}
